import { Component } from "react";
import FilterMenu from "../../components/FilterMenu";
import SliderCards from "../../components/SliderCards";

import { withRouter } from "react-router";
import CardDetail from "../../components/Card/CardDetail";
import MasonryCards from "../../components/MasonryCards";
import AppContext from "../../contexts/AppContext";
import Card from "../../model/Card";
import Category from "../../model/Category";
import "./style.scss";

class Main extends Component {

    static contextType = AppContext;

    state = {
        cardDataDetail: null,
        scrollY: 0,
        allCategories: null,
        allCategoriesByUrl: null,
        cardsByCat: null,
        cards: null,
        favorites: null
    }

    cardClickHandler = (data) => {
        this.setState({ cardDataDetail: data, scrollY: window.scrollY });
    }

    closeDetail = () => {
        this.setState({ cardDataDetail: null });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.cardDataDetail !== this.state.cardDataDetail) {
            if (!this.state.cardDataDetail && this.state.scrollY) {
                requestAnimationFrame(() => {
                    window.scrollTo(0, this.state.scrollY);
                    this.setState({ scrollY: 0 });
                });
            } else if (this.state.cardDataDetail && this.state.scrollY) {
                window.scrollTo(0, 0);
            }
        }

        let catUrl = this.props.match.params.title;
        let categorySelected = catUrl ? this.state.allCategoriesByUrl[catUrl] : null;
        let selectedCatId = categorySelected ? categorySelected.id : 1;

        if (this.selectedCatId !== selectedCatId) {
            this.selectedCatId = selectedCatId;
            this.setState({cardsByCat:null, favorites:null});
            setTimeout(this.loadCards, 500);
        }
    }

    componentDidMount() {
        //request from API
        let data = {
            allCategories: [
                { id: 1, title: "All Categories", url: "all" },
                { id: 2, title: "Favorites", url: "favorites" },
                { id: 3, title: "Red Wagon", url: "red-wagon" },
                { id: 4, title: "Congratulations", url: "congratulations" },
                { id: 5, title: "Seasonal Holidays", url: "seasonal-holidays" },
                { id: 6, title: "New Baby", url: "new-baby" },
                { id: 7, title: "Customizable Cards", url: "/customizable" },
                { id: 8, title: "Encouragement / Condolences", url: "encouragement-condolences" },
                { id: 9, title: "Anniversary", url: "anniversary" },
                { id: 10, title: "Fall", url: "fall" },
                { id: 11, title: "Everyday", url: "everyday" },
                { id: 12, title: "Thank You", url: "thank-you" },
                { id: 13, title: "Real Estate", url: "real-estate" },
                { id: 14, title: "Just For Fun", url: "just-for-fun" },
                { id: 15, title: "For Business", url: "for-business" },
                { id: 16, title: "Mother's Day", url: "mothers-day" },
                { id: 17, title: "Father's Day", url: "fathers-day" },
                { id: 18, title: "Valentine's Day / Love", url: "valentines-day-love" },
                { id: 19, title: "Handwrytten Cares", url: "handwrytten-cares" },
                { id: 20, title: "Birthday", url: "Birthday" }
            ]
        }

        //all categories
        let allCategories = []
        data.allCategories.forEach(obj => {
            allCategories.push(new Category(obj.id, obj.title, obj.url))
        });
        let allCategoriesObj = {};
        let allCategoriesByUrl = {};
        allCategories.forEach(category => {
            allCategoriesObj[category.id] = category;
            allCategoriesByUrl[category.url] = category;
        });
        this.context.setAllCategories(allCategoriesObj);

        let state = this.state;
        state.allCategories = allCategories;
        state.allCategoriesByUrl = allCategoriesByUrl;
        this.setState(state)
    }

    onCardUpdate = (data) => {
        let favorites = [];
        this.state.favorites.forEach(card => {
            if (card.favorite) favorites.push(card)
        });
        if (data.favorite) favorites.unshift(data);

        let state = this.state;
        state.favorites = favorites;
        this.setState(state);
    }

    loadCards = () => {
        console.log("loadCards", this.selectedCatId);

        //request from api
        let data;
        if (this.selectedCatId === 1) {
            data = {
                cardsByCategories: [
                    {
                        catId: 3,
                        cards: [
                            { id: 1, name: "Teal Holidays", price: 3.25, frontImage: "https://placehold.co/300/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300/000000/FFFFFF/?text=Back", type:2 },
                            { id: 2, name: "Festive Holidays", price: 95.25, frontImage: "https://placehold.co/300x200/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x200/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x200/000000/FFFFFF/?text=Back" },
                            { id: 3, name: "Well Wishes this Season", price: 8, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back" }
                        ]
                    },
                    {
                        catId: 4,
                        cards: [
                            { id: 7, name: "Teal Holidays 2", price: 3.25, frontImage: "https://placehold.co/300/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300/000000/FFFFFF/?text=Back", favorite: true },
                            { id: 8, name: "Festive Holidays 2", price: 95.25, frontImage: "https://placehold.co/300x200/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x200/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x200/000000/FFFFFF/?text=Back", favorite: true },
                            { id: 9, name: "Well Wishes this Season 2", price: 8, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back" },
                            { id: 10, name: "Happy Holidays 4", price: 1.86, frontImage: "https://placehold.co/300x250/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300/300x250/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x250/000000/FFFFFF/?text=Back" },
                            { id: 11, name: "Happy Holidays 5", price: 1.86, frontImage: "https://placehold.co/300x250/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300/300x250/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x250/000000/FFFFFF/?text=Back" }
                        ]
                    },
                    {
                        catId: 5,
                        cards: [
                            { id: 13, name: "Teal Holidays 3", price: 3.25, frontImage: "https://placehold.co/300/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300/000000/FFFFFF/?text=Back" },
                            { id: 14, name: "Festive Holidays 3", price: 95.25, frontImage: "https://placehold.co/300x200/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x200/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x200/000000/FFFFFF/?text=Back" },
                            { id: 15, name: "Well Wishes this Season 3", price: 8, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back" },
                            { id: 16, name: "Happy Holidays 7", price: 1.86, frontImage: "https://placehold.co/300x250/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x250/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x250/000000/FFFFFF/?text=Back" },
                            { id: 17, name: "Happy Holidays 8", price: 1.86, frontImage: "https://placehold.co/300x250/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x250/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x250/000000/FFFFFF/?text=Back" },
                            { id: 18, name: "Happy Holidays 9", price: 1.86, frontImage: "https://placehold.co/300x250/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x250/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x250/000000/FFFFFF/?text=Back" }
                        ]
                    }
                ]
            }
        } else {
            data = {
                cardsByCategories: [
                    {
                        catId: 3,
                        cards: [
                            { id: 1, name: "Teal Holidays", price: 3.25, frontImage: "https://placehold.co/300/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300/000000/FFFFFF/?text=Back", favorite: true },
                            { id: 2, name: "Festive Holidays", price: 95.25, frontImage: "https://placehold.co/300x200/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x200/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x200/000000/FFFFFF/?text=Back", favorite: false },
                            { id: 3, name: "Well Wishes this Season", price: 8.1, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back", favorite: false },
                            { id: 4, name: "Well Wishes this Season 2", price: 8.2, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back", favorite: true },
                            { id: 5, name: "Well Wishes this Season 3", price: 8.3, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back", favorite: false },
                            { id: 6, name: "Well Wishes this Season 4", price: 8.4, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back", favorite: false },
                            { id: 7, name: "Well Wishes this Season 5", price: 8.5, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back", favorite: false },
                            { id: 8, name: "Well Wishes this Season 6", price: 8.6, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back", favorite: false },
                            { id: 9, name: "Well Wishes this Season 7", price: 8.7, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back", favorite: false },
                            { id: 10, name: "Well Wishes this Season 8", price: 8.8, frontImage: "https://placehold.co/300x500/FFFF00/FFFFFF/?text=Front", frontInsideImage: "https://placehold.co/300x500/808080/FFFFFF/?text=Inside", backImage: "https://placehold.co/300x500/000000/FFFFFF/?text=Back", favorite: false },
                        ]
                    }
                ]
            }
        }

        //cards
        let cardsByCat = [];
        let favorites = [];
        data.cardsByCategories.forEach(obj => {
            let catId = obj.catId;
            let category = this.context.allCategories[catId];
            let cards = [];
            obj.cards.forEach(cardObj => {
                let card = new Card(cardObj, category);
                cards.push(card);
                if (cardObj.favorite) favorites.unshift(card);
            });
            cardsByCat.push({ catId: catId, cards: cards });
        });
        let cards = [];
        cardsByCat.forEach(obj => cards = cards.concat(obj.cards));

        let state = this.state;
        state.cards = cards;
        state.cardsByCat = cardsByCat;
        state.favorites = favorites;
        this.setState(state)
    }

    render() {
        let { cardDataDetail, cardsByCat, favorites } = this.state;

        return (
            <>
                <FilterMenu categories={this.state.allCategories} selectedID={this.selectedCatId} />
                <div className="container">
                    {
                        (!this.props.match.params.title || this.props.match.params.title==='all') && cardDataDetail ?
                            <CardDetail data={cardDataDetail} onBack={this.closeDetail} onCardUpdate={this.onCardUpdate} />
                            :
                            (
                                this.selectedCatId===1 ?
                                    [
                                        favorites && favorites.length ? <SliderCards key="g-00" title="Favorites" cards={favorites} onCardClick={this.cardClickHandler} onCardUpdate={this.onCardUpdate} /> : null,

                                        cardsByCat ?
                                            cardsByCat.map((obj, i) => {
                                                let category = this.context.allCategories[obj.catId];
                                                let cards = obj.cards;
                                                return (<SliderCards key={`g-${i}`} title={category.title} cards={cards} onCardClick={this.cardClickHandler} onCardUpdate={this.onCardUpdate} />)
                                            }) : null
                                    ] :
                                    cardsByCat ?
                                        <MasonryCards cards={cardsByCat[0].cards} /> : null
                            )
                    }
                </div>
            </>
        )
    }
}

export default withRouter(Main);